import { Snackbar } from 'maple-storybook'

const CustomSnackbar = ({ open, vertical, horizontal, children }) => {
  return <Snackbar anchorOrigin={{ vertical, horizontal }} open={open} message={children} key={vertical + horizontal} />
}

export default CustomSnackbar
